export default "__VITE_ASSET__899c6d52__"